//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  WritableSignal,
  signal,
} from "@angular/core";

//local imports
import { PresenterType } from "@shared/components";
import { DepartmentAddedMessage } from "./department-added.message";

@PresenterType({
  model: DepartmentAddedMessage,
})
@Component({
  selector: "department-added-message-template",
  templateUrl: "./department-added-message-template.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DepartmentAddedMessageTemplateComponent {
  public data: WritableSignal<DepartmentAddedMessage>;

  constructor() {
    this.data = signal<DepartmentAddedMessage>(null);
  }
}
